module.exports = __webpack_public_path__ + "img/winner5.0984452a.png";